module.exports = __webpack_public_path__ + "static/media/event-decor.1b720746.png";